import axios from 'axios';

export const catalogService = {
  async getSuppliers() {
    const response = await axios.get('/catalog/suppliers');
    return response.data;
  },

  async getMasters(catalogSupplierId) {
    const response = await axios.get('/catalog/masters', {
      params: { catalog_supplier_id: catalogSupplierId },
    });
    return response.data;
  },

  async previewVersion(versionId) {
    const response = await axios.get(`/catalog/versions/${versionId}`);
    return response.data;
  },

  async install(body) {
    const response = await axios.post('/catalog/installations', body);
    return response.data;
  },

  async getInstallation(installationId) {
    const response = await axios.get(`/catalog/installations/${installationId}`);
    return response.data;
  },

  async updateInstallation(installationId, body) {
    const response = await axios.patch(`/catalog/installations/${installationId}`, body);
    return response.data;
  },

  // The API replaces price_overrides as a whole; read the latest list so a
  // choice save does not drop the matrix and vice versa.
  async updatePriceOverrides(installationId, change) {
    const { installation } = await this.getInstallation(installationId);
    const next = change(
      Array.isArray(installation?.price_overrides) ? installation.price_overrides : []
    );
    return this.updateInstallation(installationId, { price_overrides: next });
  },
};
